const membersData = [
  {
    name: "Amogh M",
    role: "Technical team Head",
    imageUrl: "./images/members/amogh-bharadwaj.jpg",
    linkedinUrl: "https://www.linkedin.com/in/amogh-m-985490216/",
  },

  {
    name: "Anand Okade",
    role: "Committee member-Technical team",
    imageUrl: "./images/members/anand-okade.jpg",
    linkedinUrl: "https://www.linkedin.com/in/anand-okade-a9614a220/",
  },

  {
    name: "Ayaj Anand",
    role: "Committee member-Technical team",
    imageUrl: "./images/members/ayaj-anand.jpg",
    linkedinUrl: "https://www.linkedin.com/in/ayaj-anand-492986127/",
  },

  {
    name: "Amogh Athreya H",
    role: "Committee member-Marketing team",
    imageUrl: "./images/members/amogh-athreya.jpg",
    linkedinUrl: "https://www.linkedin.com/in/amogh-athreya-454515254",
  },
  
  {
    name: "Nishitha R Lokhande",
    role: "Committee member-Technical team",
    imageUrl: "./images/members/nishitha-L.jpg",
    linkedinUrl: "https://www.linkedin.com/in/nishitha-r-lokande-094509254",
  },

  {
    name: "Ranjitha V",
    role: "Committee member-Organising team",
    imageUrl: "./images/members/ranjitha-s.jpg",
    linkedinUrl: "#", // Add the correct LinkedIn URL here
  },

  {
    name: "Sujal S",
    role: "Committee member-Organising team",
    imageUrl: "./images/members/sujal.jpg",
    linkedinUrl: "https://www.linkedin.com/in/sujal-sarode-3a5b3a25b",
  },

  {
    name: "Dhruva N U",
    role: "Committee member-Technical team",
    imageUrl: "./images/members/dhruva-nu.jpg",
    linkedinUrl: "https://www.linkedin.com/in/dhruva-n-u-b6788a249/",
  },
  
  {
    name: "Apeksha D Ankola",
    role: "Committee member-Technical team",
    imageUrl: "./images/members/apeksha-d.jpg",
    linkedinUrl: "https://www.linkedin.com/in/apeksha-d-ankola-aa4512254/",
  },
  

  {
    name: "Aadi B Kumar",
    role: "Marketing team Head",
    imageUrl: "./images/members/aadi-kumar.jpg",
    linkedinUrl: "https://www.linkedin.com/in/aadi-b-kumar-584514254",
  },

  {
    name: "Amogh N Kotha",
    role: "Club Head",
    imageUrl: "./images/members/amogh-kotha.jpg",
    linkedinUrl: "https://www.linkedin.com/in/amogh-kotha-a5617823b",
  },
  
  
];

export default membersData;